import PropTypes from 'prop-types';
import Modal from '@/components/modal/modal-component';
import ProductOptionForm from './product-option-form';

/**
 * Item component for displaying an option menu.
 * @param {object} props - The props passed to the OptionMenu component.
 * @param {object | bool} props.isOpen - Hide or show modal.
 * @param {Function} props.setIsOpen - Set modal state.
 * @param {Function} props.onSubmit - Handle form submission.
 * @param {string} props.name - The name of the field array.
 * @param {object} props.CONTEXT - The context to use.
 * @returns {JSX.Element} The rendered Item component.
 */
const ProductOptionModal = ({ isOpen, setIsOpen, onSubmit, name, CONTEXT }) => (
  <Modal
    open={isOpen}
    showClose
    // title="Add/Edit Product option"
    title={`${!isOpen?.values ? 'Add' : 'Edit'} Product Option`}
    close={() => setIsOpen(false)}
    width="500px"
    bodyStyle={{
      padding: '0px',
    }}
  >
    <ProductOptionForm
      onSubmit={onSubmit}
      defaultValues={isOpen}
      name={name}
      CONTEXT={CONTEXT}
    />
  </Modal>
);

ProductOptionModal.defaultProps = {
  isOpen: false,
};

ProductOptionModal.propTypes = {
  isOpen: PropTypes.oneOfType([PropTypes.bool, PropTypes.object]),
  setIsOpen: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  CONTEXT: PropTypes.object.isRequired,
  name: PropTypes.string.isRequired,
};

export default ProductOptionModal;
